import React from "react";
import ReactDOM from "react-dom/client";
import "./i18nextConf";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import UserProvider from "./context/UserContext";
import UniversityProvider from "./context/UniversityContext";
import SemesterProvider from "./context/SemesterContext";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_AICE_BASE_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <UserProvider>
    <UniversityProvider>
      <SemesterProvider>
        <React.StrictMode>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </React.StrictMode>
      </SemesterProvider>
    </UniversityProvider>
  </UserProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
